import { moreThanThreeCardsSwiperCards } from '@sections/cards/more_than_three_cards/swiper';
import { threeCardsSwiperCards } from '@sections/cards/three_cards/swiper';

document.addEventListener("DOMContentLoaded", function(_event) {
  // Trigger the correct swiper js if we are on 3 cards view or more than 3 cards view.
  if (document.getElementsByClassName('swiper-cards-three-cards').length > 0) {
    threeCardsSwiperCards();
  } else if (document.getElementsByClassName('swiper-cards-more-than-three-cards').length > 0) {
    moreThanThreeCardsSwiperCards;
  }
});
